const APPID = 'wxa9d28054f0e1e8eb';

export default{
	APPID,
}




